import React, { useEffect } from 'react';
import { useDispatch, useSelector } from 'react-redux';
import { usePrefs } from 'wsm-common-data';

import PaymentSelectorView from '../components/PaymentSelectorView';
import StepContainer from '../components/StepContainer';
import { setSteps } from '../features/steps/stepsSlice';
import { setVehicleId } from '../features/vehicleId/vehicleIdSlice';
import { setListingType } from '../features/listingType/listingTypeSlice';
import { getLsWidgetStateByVehicleId } from '../helpers';

import '../global-sass/main.scss';

const Widget = () => {
	const { trackMyOfferView } = usePrefs();
	const dispatch = useDispatch();
	const steps = useSelector((state) => state.steps);
	const isPaymentSelectorView = trackMyOfferView === 'paymentSelector';

	useEffect(() => {
		// TODO: refactor to set these on server side
		const uuid = window?.DDC?.dataLayer?.vehicles[0]?.uuid || '';
		const listingType =
			window?.DDC?.dataLayer?.vehicles[0]?.inventoryType || '';

		// payment selector view handles read, write from local storage and publish steps to step tracker
		if (uuid && isPaymentSelectorView) {
			const lsSteps = getLsWidgetStateByVehicleId(uuid, steps);
			// TODO: validate LS steps before pushing to state
			dispatch(setSteps(lsSteps));

			// TODO: refactor to set these on server side
			dispatch(setVehicleId(uuid));
			dispatch(setListingType(listingType));
		}
		// eslint-disable-next-line react-hooks/exhaustive-deps
	}, []);

	return isPaymentSelectorView ? <PaymentSelectorView /> : <StepContainer />;
};

Widget.propTypes = {};

export default Widget;
